import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/qna';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            isOn: false
        };

        this.toggleAnswer = this.toggleAnswer.bind(this);
    }

    toggleAnswer() {
        this.setState(prevState => {
            return {
                isOn: !prevState.isOn
            };
        });
    }
}
